 
import React from "react";
import DialogLayout from "../../../Components/DialogLayout";
import { DV2 } from "../theme";
import { vocab } from "../vocabulary";
import { useDv2Theme } from "../layout/Ui";

interface Props {
    open: boolean;
    /** « le vendredi 30 octobre de 14h00 à 15h30 » ou « de 3 séances entre le … et le … ». */
    description: React.ReactNode;
    onConfirm: () => void;
    onClose: () => void;
}

/**
 * Déclaration d'un cours déjà passé : même avertissement que l'ancien
 * parcours (une fois déclaré, plus de modification ni de suppression).
 */
const PastCourseDialog = ({ open, description, onConfirm, onClose }: Props) => {
    const { fontFamily } = useDv2Theme();
    return (
        <DialogLayout
            title={`Déclaration ${vocab.aCourse().replace(/^un /, "d'un ").replace(/^une /, "d'une ")} ${vocab.past()}`}
            text={
                <p style={{ fontFamily, fontSize: 15, lineHeight: 1.55, color: DV2.text, margin: 0 }}>
                    Vous êtes sur le point de déclarer {vocab.aCourse()} déjà réalisé {description}.
                    Une fois {vocab.declared()}, <strong style={{ color: DV2.danger }}>{vocab.thisCourse()} ne pourra plus être modifié ni supprimé</strong>.
                    Merci de vérifier que les informations sont exactes.
                </p>
            }
            open={open}
            cancel="Retour"
            valid="Déclarer quand même"
            handleSubmit={onConfirm}
            handleClose={onClose}
        />
    );
};

export default PastCourseDialog;
